<template>
  <main>
    <VSpin :value="true"/>
  </main>
</template>
<script>
import VSpin from '@/components/VSpin.vue'
import { paymentSuccessMessage, redirectPostMessage } from '@/app/commands/pagesCommands'

export default {
  name: 'PaymentSuccessPrepare',
  components: {
    VSpin,
  },
  mounted() {
    redirectPostMessage({ title: paymentSuccessMessage, description: '' })
  }
}
</script>
<style lang="scss">

</style>